type HostRequest = {
  query?: { baseUrl?: string };
  headers?: { host?: string };
  protocol?: string;
  cookies?: Partial<{
    [key: string]: string;
  }>;
};

export const getHostHeadersWithoutToken = (
  req: HostRequest
): { baseUrl: string } => {
  const baseUrl =
    process.env.DEV_API_ENDPOINT || `https://${req?.headers?.host}`;

  return { baseUrl };
};
